<template>
    <div id="app">
        <notifications/>

        <fade-transition :duration="200" mode="out-in">
            <router-view/>
        </fade-transition>
    </div>
</template>

<script>
import { FadeTransition } from 'vue2-transitions'
import { mapState } from 'vuex'

export default {
    components: {
        FadeTransition
    },
    computed: {
        ...mapState([
            'user'
        ])
    },
    data () {
        return {
            timer: null
        }
    },
    mounted () {
        this.getSettings()

        window.onresize = () => {
            this.onResize()
        }
        this.onResize()

        this.restartInactivityTimer()

        document.addEventListener('click', () => {
            this.restartInactivityTimer()
        })

        window.addEventListener('scroll', () => {
            this.restartInactivityTimer()
        })
    },
    methods: {
        getSettings: async function () {
            try {
                await this.$store.dispatch('get', { path: 'settings', key: 'settings', id: '' })
            } catch (e) {
                console.log(e)
                // console.log('error getting settings')
            }
        },
        onResize: function () {
            this.$store.commit('SET_PROPS', ['width', window.innerWidth])
            this.$store.commit('SET_PROPS', ['isMobile', window.innerWidth < 768])
        },
        restartInactivityTimer: function () {
            clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                if (this.user._id) {
                    this.$store.dispatch('logout')
                    this.$notify({ type: 'danger', message: 'Session expired!' })
                    this.$router.push({ name: 'login' })
                }
            }, 1800 * 1000) // 30 minutes
        }
    }
}
</script>

<style lang="sass" src="./assets/css/main.sass"/>
